import { fetchWrapper, handleResponse, buildOpts, hcUrlV3 } from 'services/RequestService/helpers';

const getQuickFilters = async ({ params }) => {
  const { menuSlug, mealPlanSlug } = params;

  const response = await fetchWrapper(
    hcUrlV3(`/quick_filters/${menuSlug}/${mealPlanSlug}`),
    buildOpts()
  );
  return handleResponse(response);
};

export { getQuickFilters };
